import { render, staticRenderFns } from "./DeleteFAQButton.vue?vue&type=template&id=40497e23&"
import script from "./DeleteFAQButton.vue?vue&type=script&lang=js&"
export * from "./DeleteFAQButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports